import { toProductListCategoryOrUniversePage } from '@/feature/universe/services/universe.routing'
import { assertNever } from '@/lib/typescript/assertNever'
import { ensureLeadingSlash } from '@/lib/utils/link-utils'
import type { MenuEntryFragment } from '@gql-generated/graphql'

/**
 * Go to the not found page.
 */
export const toNotFoundPage = '/404'

/**
 * URL to go to the forbidden page.
 */
export const toForbiddenPage = '/403'

export function toMenuEntryPage(menuEntry: MenuEntryFragment): string {
  switch (menuEntry.__typename) {
    case undefined:
      return toNotFoundPage
    case 'MenuEntryLink':
      return ensureLeadingSlash(menuEntry.url)
    case 'MenuEntryCategory':
      return toProductListCategoryOrUniversePage(menuEntry.slug)
    default:
      assertNever(menuEntry)
  }
}
